import React, { useId } from 'react';
import { DS } from './ds';
import { AlinovaConstellation } from './Visuals';
type EvidenceKind = 'scan' | 'plan' | 'fabrication';
interface TechnologyEvidenceCardProps {
  badge: string;
  title: string;
  description: string;
  kind: EvidenceKind;
}
const fabricationSteps = ['Modelo 3D generado', 'TPU termoformado', 'Corte CNC precisión', 'Control QA por unidad', 'Empaque eco-premium'];
export function TechnologyEvidenceCard({
  badge,
  title,
  description,
  kind
}: TechnologyEvidenceCardProps) {
  const id = useId().replace(/:/g, '');
  return <article style={{
    position: 'relative',
    overflow: 'hidden',
    minHeight: '292px',
    borderRadius: '22px',
    border: `1px solid ${DS.color.border}`,
    background: DS.color.white,
    boxShadow: DS.shadow.card,
    display: 'flex',
    flexDirection: 'column',
    transition: `box-shadow 0.25s ${DS.ease.smooth}, transform 0.25s ${DS.ease.smooth}`
  }} onMouseEnter={e => {
    e.currentTarget.style.boxShadow = DS.shadow.cardHover;
    e.currentTarget.style.transform = 'translateY(-4px)';
  }} onMouseLeave={e => {
    e.currentTarget.style.boxShadow = DS.shadow.card;
    e.currentTarget.style.transform = 'translateY(0)';
  }} data-id="element-875" data-mp="2vbgiqco3qzc9">
      {/* Grid CAD sutil sobre ivory */}
      <div aria-hidden="true" style={{
      position: 'absolute',
      inset: 0,
      backgroundImage: 'linear-gradient(rgba(26,95,115,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(26,95,115,0.03) 1px, transparent 1px)',
      backgroundSize: '24px 24px',
      pointerEvents: 'none',
      zIndex: 0
    }} data-id="element-876" data-mp="12q0liorfq3u6" />

      <AlinovaConstellation width={250} height={250} opacity={0.04} rotation={kind === 'plan' ? 'counterclockwise' : 'clockwise'} style={{
      position: 'absolute',
      left: '50%',
      top: '44px',
      transform: 'translateX(-50%)',
      pointerEvents: 'none'
    }} data-id="element-877" data-mp="jv3jnjnygypg" />

      {/* Video */}
      <div style={{
      position: 'relative',
      height: '184px',
      overflow: 'hidden'
    }} data-id="element-878" data-mp="h9cj7gtgvf8e">
        {kind === 'scan' && <ScanEvidence data-id="element-879" data-mp="7ihve80ko7ku" />}
        {kind === 'plan' && <PlanEvidence data-id="element-880" data-mp="7j9h8r4daqxx" />}
        {kind === 'fabrication' && <FabricationEvidence data-id="element-881" data-mp="v8lo3kc82mx2" />}
      </div>

      {/* Badge */}
      <div style={{
      position: 'absolute',
      top: '14px',
      left: '14px',
      padding: '5px 12px',
      borderRadius: '10px',
      background: DS.color.mint,
      border: `1px solid ${DS.color.aquaLight}`,
      color: DS.color.teal,
      fontFamily: DS.font.body,
      fontSize: '10px',
      fontWeight: 700,
      letterSpacing: '.08em',
      textTransform: 'uppercase' as const,
      zIndex: 2
    }} data-id="element-882" data-mp="v93w1e88ypkt">
        {badge}
      </div>

      {/* Texto inferior */}
      <div style={{
      position: 'relative',
      zIndex: 1,
      padding: '18px 20px 20px',
      borderTop: `1px solid ${DS.color.border}`,
      background: DS.color.white,
      flexGrow: 1
    }} data-id="element-883" data-mp="1t0sc4b4aspjs">
        <h3 style={{
        fontFamily: DS.font.heading,
        fontWeight: 700,
        fontSize: '1rem',
        color: DS.color.ink,
        marginBottom: '5px'
      }} data-id="element-884" data-mp="2207093wzso14">
          {title}
        </h3>
        <p style={{
        fontFamily: DS.font.body,
        fontSize: '12px',
        lineHeight: 1.55,
        color: DS.color.muted
      }} data-id="element-885" data-mp="15dbt5z2xa75i">
          {description}
        </p>
      </div>
    </article>;
}
function ScanEvidence() {
  return <video src="https://cdn.magicpatterns.com/uploads/9jHZcpQqo2VBACDNZWr78T/video%20escaneo.mp4" autoPlay loop muted playsInline style={{
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    backgroundColor: DS.color.white,
    transform: 'scale(1.55) translateX(-1.5%)'
  }} data-id="element-886" data-mp="qml1qs58ta2x" />;
}
function PlanEvidence() {
  return <video src="https://cdn.magicpatterns.com/uploads/bjcT4Z9c7ahsRs57JmD1Wb/video%20planeacion%20(1).mp4" autoPlay loop muted playsInline style={{
    position: 'absolute',
    inset: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    backgroundColor: DS.color.white,
    transform: 'scale(1.45) translate(1%, 4%)'
  }} data-id="element-887" data-mp="1973jxd8zwlwe" />;
}
function FabricationEvidence() {
  return <>
      <video src="https://cdn.magicpatterns.com/uploads/1dp9TMjT4FqgppkweRNY5A/IMG_5865%20(1).mov" autoPlay loop muted playsInline style={{
      position: 'absolute',
      inset: 0,
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      backgroundColor: '#000',
      transform: 'rotate(-90deg) scale(2.6) translateX(-2%)'
    }} data-id="element-888" data-mp="1wy8y7nzaf64l" />
      <div style={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '12%',
      backgroundColor: '#000'
    }} data-id="element-889" data-mp="3hgjqq76oa8iy" />
      <div style={{
      position: 'absolute',
      bottom: 0,
      left: 0,
      right: 0,
      height: '12%',
      backgroundColor: '#000'
    }} data-id="element-890" data-mp="3ci8fbs0qbpym" />
    </>;
}